<div class="agent-portfolio-container">
  <table class="portfolio-table" *ngIf="customers.length">
    <thead>
      <tr class="row header">
        <th>
          <mat-checkbox
            [checked]="isAllLocationsSelected()"
            [indeterminate]="isPartialSelectedAll()"
            [disabled]="!canSubmit"
            (change)="toggleAllLocations($event.checked)"
          >
          </mat-checkbox>
          <div class="sortable-column">
            {{ "agent.portfolio.company" | translate }}
            <div class="sort-actions">
              <span
                class="arrow-up"
                [class.active]="
                  activeSortMode == 'asc' && activeSortKey == 'name'
                "
                (click)="sortByKey('name', 'asc')"
              ></span>
              <span
                class="arrow-down"
                [class.active]="
                  activeSortMode == 'desc' && activeSortKey == 'name'
                "
                (click)="sortByKey('name', 'desc')"
              ></span>
            </div>
          </div>
        </th>
        <th class="sortable-column">
          {{ "agent.portfolio.locations" | translate }}
          <div class="sort-actions">
            <span
              class="arrow-up"
              [class.active]="
                activeSortMode == 'asc' && activeSortKey == 'locations_count'
              "
              (click)="sortByKey('locations_count', 'asc')"
            ></span>
            <span
              class="arrow-down"
              [class.active]="
                activeSortMode == 'desc' && activeSortKey == 'locations_count'
              "
              (click)="sortByKey('locations_count', 'desc')"
            ></span>
          </div>
        </th>
        <th class="sortable-column">
        </th>
      </tr>
    </thead>
    <tbody>
      <cdk-virtual-scroll-viewport
        itemSize="50"
        class="portfolio-viewport"
        (scroll)="onScroll($event)"
      >
        <ng-container
          *cdkVirtualFor="
            let company of customers;
            trackBy: trackByCustomerId
          "
        >
          <!-- Company row -->
          <tr
            class="row"
            [style]="{
              height: '70px'
            }"
          >
            <td>
              <mat-checkbox
                [checked]="isCompanyFullySelected(company.id)"
                [disabled]="!canSubmit"
                (change)="toggleCompanyLocations(company.id, $event.checked)"
              ></mat-checkbox>
              <span
                class="truncate"
                style="width: 300px"
                [title]="company.name"
              >
                {{ company.name }}
              </span>
            </td>
            <td>
              <div style="display: flex; flex-direction: column">
                <span>
                  {{ company.locations.length }}
                </span>
                <span class="secondary-text">
                  Out of {{ company.nbr_locations }}
                </span>
              </div>
            </td>
            <td
              class="last-column"
            >
              <button
                class="action-btn secondary-btn icon-btn"
                (click)="toggleCompanyExpand(company)"
              >
                <img
                  src="assets/icones/arrow.svg"
                  alt=""
                  class="arrow-icon"
                  [class.rotated]="!isCompanyExpanded(company)"
                />
              </button>
            </td>
          </tr>
          <!-- Location rows -->
          <tr
            class="row secondary-row"
            *ngFor="let location of company.locations"
            [@expandCollapse]="
              isCompanyExpanded(company) ? 'expanded' : 'collapsed'
            "
          >
            <td>
              <img src="assets/icones/include_icon.svg" alt="" />
              <div style="display: flex; flex-direction: column">
                <span
                  class="truncate"
                  style="width: 250px"
                  [title]="location.name"
                >
                  {{ location.name }}
                </span>
                <span
                  style="width: 250px"
                  class="secondary-text truncate"
                  [title]="location.apartment"
                >
                  {{ location.apartment }}
                </span>
              </div>
            </td>
            <td>
              <span *ngIf="location.is_main" class="tag">
                {{ "agent.portfolio.location.main" | translate }}
              </span>
            </td>
            <td *ngIf="isEdit"
              style="
                display: flex;
                flex-direction: row;
              "
            >
              <ng-container *appHasPermission="submitPermission()">
                <button
                  [matMenuTriggerFor]="menu"
                  style="width: 44px; height: 44px; color: unset"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu" yPosition="below" xPosition="before">
                  <button
                    mat-menu-item
                    class="delete-btn"
                    (click)="
                      deleteLocation(location.id)
                    "
                  >
                    <app-svg-icon svgIcon="trash-cc"></app-svg-icon>
                    {{ "agent.actions.remove_portfolio" | translate }}
                  </button>
                </mat-menu>
              </ng-container>
            </td>
          </tr>
        </ng-container>

        <div *ngIf="isLoadingMore">
          <app-loader></app-loader>
        </div>
      </cdk-virtual-scroll-viewport>
    </tbody>
  </table>
</div>